import "./Error.css";

const Error = () => {
  return (
    <div className="error_msg">
      <span className="error">ERROR!</span> Something Went Wrong!!!
    </div>
  );
};

export default Error;
